//= require bijou/cjs_shim
//= require bijou/base

require('../base');

(function ($) {
  'use strict'

  $.widget('bijou.dropdown', $.bijou.base, {
    options: {
      wrapperSelector: '.select-wrapper'
    },

    _create: function () {
      var _this = this

      this.wrapper = this.element.closest(this.options.wrapperSelector)

      this.element.on({
        'change blur validationchange': function () {
          _this._update()
        }
      })

      this._update()
    },

    _update: function () {
      this.wrapper.toggleClass('error', this.element.hasClass('error'))
      this.wrapper.toggleClass('valid', this.element.hasClass('valid'))
    }

  })
}(window.jQuery))
